var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdSkelsvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 75,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#aebcc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.572,
    d: "M118.04 1.008H6.96a5.22 5.22 0 0 0-5.22 5.218V68.33a5.22 5.22 0 0 0 5.219 5.218h111.08a5.22 5.22 0 0 0 5.219-5.218V6.226a5.22 5.22 0 0 0-5.219-5.218z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aebcc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.572,
    d: "M13.232 63.41h34.816c.998 0 1.807-.81 1.807-1.807V12.955c0-.999-.81-1.808-1.807-1.808H13.231c-.999 0-1.808.81-1.808 1.808v48.648c0 .998.81 1.807 1.808 1.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aebcc6",
    d: "M30.631 63.41H13.153a1.745 1.745 0 0 1-1.745-1.729V49.61s9.824-.424 11.474-2.514-.173-5.345-.173-5.345c-.597-.754-.754-5.988-.754-5.988l-.581-.142c-.582-.157-1.352-4.495-1.352-6.13a2.47 2.47 0 0 1 1.352-2.232s-1.478-10.61 9.258-10.61 9.257 10.61 9.257 10.61a2.47 2.47 0 0 1 1.352 2.232c0 1.572-.77 5.973-1.352 6.13l-.581.142s-.157 5.234-.755 5.988c0 0-1.823 3.254-.172 5.345 1.65 2.09 11.474 2.514 11.474 2.514v12.072a1.744 1.744 0 0 1-1.745 1.73H30.631zm80.43.252h-23.86a1.823 1.823 0 0 1-1.823-1.823A1.824 1.824 0 0 1 87.2 60.03h23.86a1.823 1.823 0 0 1 1.824 1.808 1.823 1.823 0 0 1-1.824 1.823zm.001-49.121H61.581a1.823 1.823 0 0 1-1.824-1.823 1.807 1.807 0 0 1 1.824-1.823h49.481a1.805 1.805 0 0 1 1.684 1.112c.092.22.139.457.139.695a1.82 1.82 0 0 1-1.823 1.839M90.03 26.818H61.58a1.806 1.806 0 0 1-1.823-1.807 1.824 1.824 0 0 1 1.824-1.823h28.45a1.823 1.823 0 0 1 1.684 2.518 1.81 1.81 0 0 1-1.684 1.112zm-9.1 12.368H61.58a1.823 1.823 0 1 1 0-3.647h19.35a1.81 1.81 0 0 1 1.807 1.823 1.807 1.807 0 0 1-1.807 1.824m9.1 12.199H61.58a1.823 1.823 0 0 1-1.684-2.519 1.81 1.81 0 0 1 1.685-1.112h28.45a1.807 1.807 0 0 1 1.823 1.808 1.823 1.823 0 0 1-1.823 1.823z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.955.223h123.089v74.111H.955z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdSkelsvg);
export default __webpack_public_path__ + "static/media/idSkelsvg.8df9da6e0d1cc75dea60810236d6a114.svg";
export { ForwardRef as ReactComponent };